export const CLASS_PREFIX = 'lp_';
export const ICON_CLASS_PREFIX = 'lp_icon__';
export const AUTH_UI_CLASS = 'auth-ui';
